import { useEffect, useState } from "react";

export type RiskFlowAlertSurface = "browser" | "terminal";

const activeSurfaces = new Set<RiskFlowAlertSurface>();
const CHANGE_EVENT = "fintheon:riskflow-alert-surface-change";

export function setRiskFlowAlertSurfaceActive(
  surface: RiskFlowAlertSurface,
  isActive: boolean,
) {
  const wasActive = activeSurfaces.has(surface);
  if (wasActive === isActive) return;
  if (isActive) activeSurfaces.add(surface);
  else activeSurfaces.delete(surface);
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(CHANGE_EVENT));
  }
}

export function hasActiveRiskFlowAlertSurface() {
  return activeSurfaces.size > 0;
}

export function useRiskFlowAlertSurfaceActive() {
  const [isActive, setIsActive] = useState(hasActiveRiskFlowAlertSurface);

  useEffect(() => {
    const sync = () => setIsActive(hasActiveRiskFlowAlertSurface());
    window.addEventListener(CHANGE_EVENT, sync);
    return () => window.removeEventListener(CHANGE_EVENT, sync);
  }, []);

  return isActive;
}
